import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Link, useNavigate } from "react-router";
import { toast } from "sonner";

import { authClient } from "@/lib/auth-client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Field,
  FieldGroup,
  FieldLabel,
  FieldError,
} from "@/components/ui/field";

const schema = z.object({ email: z.string().email("Correo inválido") });
type FormValues = z.infer<typeof schema>;

export default function ForgotPassword() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>({ resolver: zodResolver(schema) });

  async function onSubmit(values: FormValues) {
    const { error } = await authClient.requestPasswordReset({
      email: values.email,
      redirectTo: `${window.location.origin}/auth/reset-password`,
    });
    if (error) {
      toast.error(error.message || "No pudimos enviar el correo");
      return;
    }
    navigate("/auth/check-your-email");
  }

  return (
    <div>
      <h1 className="text-center text-3xl font-extrabold leading-tight tracking-tight">
        ¿Olvidaste tu contraseña?
      </h1>
      <p className="mt-0.5 text-center text-sm font-medium text-muted-foreground">
        Rellena el formulario para restablecerla.
      </p>

      <form onSubmit={handleSubmit(onSubmit)} className="mt-8">
        <FieldGroup>
          <Field>
            <FieldLabel htmlFor="email">
              Correo <span className="text-destructive">*</span>
            </FieldLabel>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              {...register("email")}
            />
            <FieldError errors={[errors.email]} />
          </Field>
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Enviando..." : "Enviar enlace"}
          </Button>
        </FieldGroup>
      </form>

      <p className="mt-8 text-center text-sm font-medium text-muted-foreground">
        Volver a{" "}
        <Link to="/auth/login" className="text-primary hover:underline">
          Iniciar Sesión
        </Link>
      </p>
    </div>
  );
}
